import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  AlertController,
  NavParams,
  SelectPopover,
} from "ionic-angular";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { RestProvider } from "../../providers/rest/rest";
import { DataProvider } from "../../providers/data/data";
import { ViewerPage } from "../viewer/viewer";
import * as fs from 'fs';
import * as Axios from "axios";
import { FileWriter } from "@ionic-native/file";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { catchError, retry, first } from 'rxjs/operators';
import { FORGECLIENT } from '../../environments/environment';
@IonicPage()
@Component({
  selector: "page-activity",
  templateUrl: "activity.html",
})
export class ActivityPage {
  @ViewChild("fileInput") fileInput;
  bundleForm = new FormGroup({
    bundleControl: new FormControl(),
  });
  reader = new FileReader();
  fileContent;
  fileToUpload: File = null;
  error;
  checkFile = false;
  activityList = [];
  bundleList = [];
  loading;
  nickname = FORGECLIENT.CLIENT_ID;
  appboundle_name = 'UpdateRVTParam';
  activity_name = 'UpdateRVTParam';
  zip_name = 'UpdateRVTParam.zip';
  alias = '23';
  findAct = false;
  page = 1;
  TIMEOUT = 10 * 60;


  activeengine: number;
  status: boolean = false;
  enginename = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    private rest: RestProvider,
    public http: HttpClient,
    public AlertController: AlertController
  ) {}

  ionViewDidLoad() {    
    this.activityList = [];
    // this.rest.deleteNickName(RestProvider.CLIENT_ID).subscribe(res2 => {
      // console.log(res2);
      /*this.rest.setNickName(this.nickname).subscribe(res => {
        console.log(res);
      });*/
    // });
    this.getAllActivities();
  }
  
  getAllActivities() {
    this.presentLoadingWithOptions();
    this.rest.getDefinedActivities(this.page).subscribe(activities => {
      activities.data.forEach(element => {
        if(element.split('.')[1].split('+')[0].contains(this.activity_name)) {
          this.activityList.push(element);
        }
      });
      this.stopLoading();
    });
  }

  deleteActivity(id) {
    this.rest.deleteActivity(id.split('.')[1].split('+')[0]).subscribe( response => {
      this.bundleList = [];
      this.page = 1;
      this.activityList = [];
      this.getAllActivities();
    });
  }

  engineSelect(engine) {
    this.status = !this.status;
    this.enginename = engine;
    let engineSplit = engine.split('.');
    console.log(engineSplit);
    console.log("##########  GET DEFINED APP BUNDLES  ##########");
    this.bundleList = [];
    this.createAppBundle();
  }

  bundleSelect (bundle) {
    console.log(bundle);
  }

  createAppBundle() {
    console.log("getDefinedAppbundles <>");
    this.rest.getDefinedAppbundles(this.page).subscribe( bundles => {
      console.log("bundles => " ,bundles);
      bundles.data.forEach(element => {
        console.log('BUND: ' + element);
        this.bundleList.push(element);
      });
      if(bundles.paginationToken !== null) {
        console.log('Ene yum tai baina');
        this.page++ ;
        this.createAppBundle();
      } else {        
        console.log(0);
      }
    });
  }

  deleteAppbundle(id) {
    console.log('eniig ustgiii => ',id);
    this.rest.deleteAppBundle(id.split('.')[1].split('+')[0]).subscribe( response => {
      console.log(response);
      this.bundleList = [];
      this.page = 1;
      this.createAppBundle();
    })
  }

  async onSubmit() {
    let jsonInput = JSON.parse(localStorage.getItem('jsonInput'));
    console.log('json input on submit =>',jsonInput);
    this.presentLoadingWithOptions();
    let qualifiedAppBundleId = this.nickname + '.' + this.activity_name + '+' + this.alias;
    this.enginename = 'Autodesk.Revit+2020'; //localStorage.getItem('engine') TODO engine iig hereglegcheer songuuldag bolgono. (Alert garch ireed asuudag baihaar)
    this.rest.createActivity(this.enginename,this.appboundle_name,qualifiedAppBundleId,this.activity_name).subscribe(active => {
      if (active == null) {
        console.log("Api amjiltgui hariu irlee");
      } else {
        // this.getAllActivities();
        this.rest.createActivityAlias(this.activity_name, this.alias).subscribe(alias => {
          if(alias == null) {
            console.log("Api amjiltgui hariu irlee");
          } else {
            // 7.CREATE WORKITEM
            let param = {};
            param['bucketKey'] = this.rest.getBucket();
            param['inputFileNameOSS'] = localStorage.getItem('inputFileNameOSS');
            param['jsonInput'] = {};
            param['jsonInput']['array'] = JSON.stringify(jsonInput);
            // param['jsonInput']['width'] = 1600.00;
            // param['jsonInput']['height'] = 800.00;
            this.rest.createWorkItem(qualifiedAppBundleId, param).subscribe(async work => {
              if(work == null) {
                console.log("Api amjiltgui hariu irlee");
              } else {
                let workItemId = work['id'];
                let ossOutputUrl = work['ossOutputUrl'];
                let outputFileNameOSS = work['outputFileNameOSS'];

                // 8.CHECK WORKITEM STATUS AND DOWNLOAD RESULT/REPORT
                let status = 'pending';
                console.log('---work item running!');
                let start_time = new Date().getTime();
                let check = true;
                
                while(check) {
                  const statusResponse = await this.rest.getWorkItemStatus(workItemId).pipe(first()).toPromise();
                    if(statusResponse == null) {
                      console.log("Api amjiltgui hariu irlee");
                    }
                    status = statusResponse['status'];
                    if(status != 'pending' && status != 'inprogress') {
                      check = false;
                      // 9.GET OUTPUT FILE OR LOG FILE     
                      if(status == 'success') {
                        console.log('--- downloading output file: ', localStorage.getItem('outputFileNameOSS'));
                        this.http
                          .get(localStorage.getItem('ossOutputUrl'), {headers: {'Authorization': 'Bearer ' + this.rest.getAccessTokenNow()}, responseType: 'blob'}).subscribe(response => {
                            console.log('response -> ',response);
                            let file = new File([response], "highbig" + new Date().getTime() + ".rvt",{type:"", lastModified:new Date().getTime()});
                            this.reader.readAsBinaryString(file);

                            this.reader.onload = (res) => {
                              let fileContent = this.reader.result.toString();
                              let bucketKey = localStorage.getItem('bucketKey');
                              this.rest
                              .uploadObjects(file, fileContent,null,null,null,null,bucketKey)
                              .subscribe((res) => {
                                let result = JSON.parse(JSON.stringify(res));
                                var urn = btoa(result.objectId);
                                // localStorage.setItem("bucket-" + this.rest.getBucket(), urn);
                                this.rest.translateObject(urn).subscribe((res) => {
                                  localStorage.setItem('urn', res.urn);
                                  localStorage.removeItem('jsonInput');
                                  this.navCtrl.push(ViewerPage, { urn: res.urn });
                                  this.stopLoading();
                                });
                              });
                            };

                            return;
                            // this.file.writeFile('C:\Users\User\Desktop', 'xaxa', response['content'], {replace: true, append: false});
                            // let options = { type: 'rvt' };
                            // let filename = outputFileNameOSS;
                            // Util.createAndDownloadBlobFile(response['content'], options, filename);
                            console.log('content irsen');
                            
                                // var a = document.createElement("a");

                                // document.body.appendChild(a);
                                // a.style = "display: none";
                                // // var json = JSON.stringify(response);
                                // // var blob = new Blob([json], {type: "octet/stream"});

                                // let url = window.URL.createObjectURL(response);
                                // a.href = url;
                                // a.download = 'ShineZoloo.rvt';
                                // a.click();
                                // window.URL.revokeObjectURL(url);



                            // saveAs(blob, 'shineZoloo.rvt');
                            console.log('content huulsan');
                            console.log('get output file succeeded: ' + localStorage.getItem('outputFileNameOSS') );   
                            this.rest.translateObject(localStorage.getItem('urn')).subscribe((res) => {
                              this.stopLoading();
                              localStorage.setItem('urn', res.urn);
                              this.navCtrl.push(ViewerPage, { urn: res.urn });
                            });                                          
                          }, error => {
                            console.log('error => ', error);
                          });            


                      } else {
                        this.stopLoading();
                        console.log('---downloading report file: ' + workItemId + '.log');
                        let reportUrl = statusResponse['reportUrl'];
                        let response = this.http
                          .get(reportUrl);
                          // this.file.writeFile('C:\Users\User\Desktop', 'log', response['content'], {replace: true, append: false})
                          console.log('get log file succeeded: ' + response['content']);
                      }
                    }
                    let elapsed_time = new Date().getTime() - start_time;
                    if(elapsed_time > this.TIMEOUT) {
                      console.log('     get work item status timeout!');
                    }                              
                }
                // this.stopLoading();
                // console.log('****work item status: ', status);
              }
            });
          }
        });
      }
    });
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    console.log('loader ---->>>>');
    return await this.loading.present();
  }
  
  async stopLoading() {
    console.log('loader <<<<----');
    return await this.loading.dismiss();
  }

  async presentAlertConfirm(activity) {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p><strong>活動</strong>を削除してもよろしいですか</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log("kankeldchla");
          }
        }, {
          text: 'はい',
          handler: () => {
            this.deleteActivity(activity);
          }
        }
      ]
    });

    await alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/activity/activity.ts